import axios from "axios";

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000
});

HTTP.interceptors.request.use(config => {
  // const token = store.getters['auth/getToken'];
  // if (token) {
  //     config.headers.Authorization = token ? `Bearer ${token}` : '';
  // }
  return config;
});

HTTP.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return error;
  }
);

export default HTTP;
